import {createStrokeSVG} from './TEMPLATE'

// tabler: ticket
export const Ticket_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M15 5l0 2',
    'M15 11l0 2',
    'M15 17l0 2',
    'M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
